import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchFilterRoutingModule } from './search-filter-routing.module';
import { SearchFilterComponent } from './search-filter.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    SearchFilterComponent
  ],
  imports: [
    CommonModule,
    SearchFilterRoutingModule,
    SharedModule,
  ]
})
export class SearchFilterModule { }
